import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Fab,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { MoveNext, MultiStepProvider, useMultiStepForm } from "./MultiFormContext";
import { ActionButton, BoxHeader, BoxRow } from "./StyledFields";
import { Clear } from "@mui/icons-material";

const style = {
  margin: 0,
  top: 20,
  right: 20,
  bottom: 'auto',
  left: 'auto',
  position: 'fixed',
};

const MultiStepForm = ({ initialValues, title, showLogo, steps, children, onClose, lastStepButtonLabel }) => {
  return (
    <MultiStepProvider>
      <MultiStepFormInner initialValues={initialValues} title={title} showLogo={showLogo} steps={steps} children={children} onClose={onClose} lastStepButtonLabe={lastStepButtonLabel} />
    </MultiStepProvider>
  );
}

const MultiStepFormInner = ({ initialValues, title, showLogo, steps, children, onClose, lastStepButtonLabel }) => {
  //const multiStepState = useMultiFormProvider();
  const {
    activeStep,
    setActiveStep,
    activePage,
    setActivePage,
    enableNext,
    setEnableNext,
  } = useMultiStepForm();

  lastStepButtonLabel = lastStepButtonLabel || "Submit Application";
  const isFirstStepFirstPage = activeStep === 0 && activePage === 0;
  const isLastStep = activeStep === steps.length - 1;

  const [backPressed, setBackPressed] = useState(false);

  useEffect(() => {
    if (backPressed) {
      setBackPressed(false);
      setEnableNext(MoveNext.ValidationRequired);
      return;
    }

    console.log("enableNext=" + enableNext);

    console.log("submitting in progress");
    if (isLastStep) {
      // _submitForm(values, actions);
    } else {
      if (enableNext === MoveNext.Step) {
        setActiveStep(activeStep + 1);
        setActivePage(0);
      } else if (enableNext === MoveNext.Page) {
        setActivePage(activePage + 1);
      } else if (enableNext === MoveNext.TwoPage) {
        setActivePage(activePage + 2);
      }
      setEnableNext(MoveNext.ValidationRequired);
      //?? setEnableNext(MoveNext.Step);
      // actions.setTouched({});
      // actions.setSubmitting(false);
    }    

  }, [enableNext, backPressed]);

  function _handleSubmit(values, actions) {
//    console.log("submitting in progress");
    if (isLastStep) {
      // _submitForm(values, actions);
    } else {

      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setBackPressed(true);
    if (activePage > 0) {
      setActivePage(activePage - 1);
    } else {
      setActiveStep(activeStep - 1);
      // On last page of previous step
    }
  }

  //?? TODO
  const debugInfo = (props) => {

  };

  return (
    <>
      <Box>
        <BoxRow >
          <BoxHeader>
          <Typography
          variant="h1"
          sx={{ flexGrow: 1, fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.4, textAlign: 'left', }}
        >
              {title}
            </Typography>
            
            {onClose &&
            <Fab size="medium" aria-label="cancel" 
            sx={{backgroundColor: '#fff', boxShadow: 'none', '&:hover': {
      bgcolor: '#bfcfdf', // #1976d2
    },}}
                onClick={onClose} style={style}>
              <Clear />
            </Fab>}
          </BoxHeader>
        </BoxRow>
        <BoxRow >

          <Stepper activeStep={activeStep} >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper> 
          <Divider sx={{ my: 4 }} />
        </BoxRow>
        </Box>
        
          <Formik initialValues={initialValues} onSubmit={_handleSubmit}>
            {(props) => (
              <Form id="createVoucherForm">
                {children(activeStep, activePage, props)}
                {debugInfo(props)}
                
                  <Box
                    sx={{
                      display: "flex",
                      bottom: 0,
                      right: 0,
                      width: "700px", // Matches the width of the immediate parent
                      paddingTop: 2,
                      paddingRight: 4,
                      paddingBottom: 4,
                      paddingLeft: 4,
                      backgroundColor: "background.paper",
                      zIndex: 1000,
                      
                    }}
                    
                  >
                    
                    <ActionButton
                      disabled={props.isSubmitting}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      {isLastStep ? lastStepButtonLabel : "Continue"}
                    </ActionButton>
                    {!isFirstStepFirstPage && (
                      <Button
                      variant="outlined"
                        sx={{
                          m: 1,
                          py: 1.5,
                          px: 8,
                          fontSize: 18,
                        }}
                        onClick={_handleBack}
                      >
                        Back
                      </Button>
                    )}
                    {props.isSubmitting && (
                      <CircularProgress
                        size={24}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                        }}
                      />
                    )}
                   
                  </Box>
               
              </Form>
            )}
          </Formik>
        
      
    </>
  );
};

export default MultiStepForm;
